<!--
  ~ Copyright (C) 2019 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="dialog-header">
  <div class="dialog-header__top">
    <img src="{{ (organizationData$ | async)?.logo }}" class="dialog-header__logo" alt="" width="88" height="67" />

    <i
      class="material-icons dialog-header__close-icon"
      [mat-dialog-close]="false"
      [attr.aria-label]="'translations.global.ariaLabels.closePublishPage' | transloco"
      tabindex="0"
      >close</i
    >
  </div>
</div>

<table class="report-outer-container">
  <tbody>
    <tr>
      <td>
        <div class="report-wrapper">
          <div class="report-wrapper__inner">
            <div class="sticky-panel beta">
              <ul class="content">
                <ng-container *ngFor="let section of reportSections">
                  <li
                    *ngIf="isShownInIndex(section)"
                    [attr.aria-label]="sectionTitle(section)"
                    (click)="scrollTo(section)"
                    (keydown.enter)="scrollTo(section)"
                  >
                    {{ sectionTitle(section) }}
                  </li>
                </ng-container>
              </ul>
            </div>

            <div class="report-view-container">
              <div class="report-view">
                <div class="report-view__headline">
                  <div class="report-view__org-logo" *ngIf="report?.showLogo">
                    <img class="logo__image" [src]="(organizationData$ | async)?.logo" alt="" />
                  </div>

                  <h2 class="report-view__title beta">{{ member?.about?.firstName }} {{ member?.about?.lastName }}</h2>
                </div>

                <div class="report-view__headline-info">
                  <div class="title" *ngIf="report?.showTitle" tabindex="0" [attr.aria-label]="report.title">
                    {{ report.title }}
                  </div>
                  <div
                    class="completed"
                    tabindex="0"
                    [attr.aria-label]="
                      'translations.global.ariaLabels.completed'
                        | transloco: { progress: (report?.completedOn | dateFormat: 'DD MMMM yyyy HH:mm') }
                    "
                  >
                    {{ 'translations.global.label.completed' | transloco }} {{ report?.completedOn | dateFormat: 'DD MMMM yyyy HH:mm' }}
                  </div>

                  <div class="report-view__pdf-btn-container">
                    <button
                      *ngIf="reportSections?.length"
                      title="Download report"
                      mat-icon-button
                      class="report-view__pdf-btn"
                      type="button"
                      [attr.aria-label]="'translations.global.ariaLabels.downloadReport' | transloco"
                      (click)="downloadReport()"
                    >
                      <img
                        *ngIf="!downloadInProgress"
                        alt="Download report"
                        src="assets/icons/pdf-file-dark.svg"
                        width="640"
                        height="640"
                      />
                      <mat-spinner *ngIf="downloadInProgress" [diameter]="20"></mat-spinner>
                    </button>
                  </div>
                </div>

                <!-- The header card the report page prints. -->
                <mat-card class="version-new-card report-view-section report-header-container print-only">
                  <div class="report-header-top">
                    <h1 class="report-header-title extra large" *ngIf="report?.showTitle">
                      {{ report?.title }}
                    </h1>

                    <button
                      *ngIf="reportSections?.length"
                      title="Download report"
                      mat-icon-button
                      class="report-view__pdf-btn"
                      type="button"
                      [attr.aria-label]="'translations.global.ariaLabels.downloadReport' | transloco"
                      (click)="downloadReport()"
                    >
                      <img
                        *ngIf="!downloadInProgress"
                        alt="Download report"
                        src="assets/icons/new/pdf-square.svg"
                        width="640"
                        height="640"
                      />
                      <mat-spinner *ngIf="downloadInProgress" [diameter]="20"></mat-spinner>
                    </button>
                  </div>

                  <div class="report-header-info">
                    <div class="report-view-org-logo" *ngIf="report?.showLogo">
                      <img [src]="(organizationData$ | async)?.logo" alt="" />
                    </div>

                    <div class="small bold">{{ member?.about?.firstName }} {{ member?.about?.lastName }}</div>

                    <div class="small completed">
                      {{ 'translations.global.label.completed' | transloco }}
                      {{ report?.completedOn | dateFormat: 'DD MMMM yyyy HH:mm' }}
                    </div>
                  </div>
                </mat-card>

                <ptl-skeleton-view
                  *ngIf="!reportLoaded; else elseTemplate"
                  [state]="{ loading: true }"
                  [viewType]="'pages'"
                ></ptl-skeleton-view>

                <ng-template #elseTemplate>
                  <ng-container *ngFor="let section of reportSections; let first = first; let i = index; trackBy: trackByFn">
                    <div
                      class="version-new-card report-view-section"
                      [ngClass]="{ 'no-padding': section.type === 'STANDARD_SECTION' || section.type === 'RESOURCE_SECTION' }"
                    >
                      <ptl-diagnostics-report-standard-section
                        *ngIf="section.type === 'STANDARD_SECTION'"
                        [isFirst]="first"
                        [class.is_first]="first"
                        [section]="section"
                        [learner]="learner"
                      >
                      </ptl-diagnostics-report-standard-section>

                      <!-- The dialog keeps the old learning goal section on screen and prints the report page's one. -->
                      <ptl-diagnostics-report-conditional-section
                        *ngIf="section.type === 'CONDITIONAL_SECTION'"
                        class="screen-only"
                        [isFirst]="first"
                        [section]="section"
                      >
                      </ptl-diagnostics-report-conditional-section>

                      <ptl-diagnostics-report-conditional-section-view
                        *ngIf="section.type === 'CONDITIONAL_SECTION'"
                        class="print-only"
                        [isPercentageEnabled]="isPercentageEnabled"
                        [levels]="levelsForSection(i)"
                        [class.is_print-hidden]="report?.reportMode !== 'FULL'"
                        [isFirst]="first"
                        [class.is_first]="first"
                        [section]="section"
                      >
                      </ptl-diagnostics-report-conditional-section-view>

                      <ptl-diagnostics-report-resource-section
                        *ngIf="section.type === 'RESOURCE_SECTION'"
                        [isFirst]="first"
                        [class.is_first]="first"
                        [sectionIndex]="i"
                        [section]="section"
                      >
                      </ptl-diagnostics-report-resource-section>
                    </div>
                  </ng-container>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
  </tbody>

  <tfoot class="footer-space-container">
    <tr>
      <td>
        <div class="footer-space">&nbsp;</div>
      </td>
    </tr>
  </tfoot>

  <div class="footer">
    <div class="top-text small">{{ (organizationData$ | async)?.name }}</div>
    <div class="bottom-text small">{{ report?.title }}</div>
  </div>
</table>
